module.exports = {
  'en': {
    'HRPM31EC1': {
      '10': 'Department',
      '20': 'Prob. due Date From',
      '30': 'To',
      '40': 'Or Employee Code',
      '50': 'Employee Code',
      '60': 'Employee Name',
      '70': 'Department',
      '80': 'Position',
      '90': 'Type of Probation',
      '99': 'Probation of employee',
      '100': 'Hired Date',
      '110': 'Probation Duedate',
      '120': 'Approve Next Step',
      '130': 'Approve Status'
    },
    'HRPM31EP1': {
      '10': 'Employee Code',
      '20': 'App. Seq.',
      '30': 'Appraiser i.d',
      '40': 'Evaluation result',
      '50': 'Detail of Appraisal',
      '60': 'Detail of Leave and Abnormal',
      '70': 'Type of Probation',
      '80': 'No.of Appraiser',
      '90': 'Persons',
      '100': 'Completed Appraisal',
      '110': 'Persons',
      '120': 'Confirmation  Date',
      '130': 'Probation Duedate',
      '140': 'Review Date',
      '150': 'Appraisal Score',
      '160': 'Result',
      '170': 'Probation Period (Day)',
      '180': 'Remarks',
      '190': 'Reason Of Fail',
      '200': 'Appraisal Status',
      '210': 'In Process',
      '220': 'Completed',
      '230': 'Detail of Probation',
      '240': 'codapp like "HRPM31EP1%"',
      '250': 'Emp. ID',
      '260': 'Department',
      '270': 'Hired Date',
      '280': 'Position',
      '290': 'Rehired Date',
      '300': 'Job Description',
      '310': 'Probation Period (Day)',
      '320': 'Type of Employment',
      '330': 'Probation Due Date',
      '340': 'Type of Employee',
      '350': 'Type of Probation',
      '360': 'Section',
      '370': 'The results are summarized',
      '380': 'pass',
      '390': 'fail',
      '400': 'Probation Period',
      '410': 'Day',
      '420': 'Remark',
      '430': 'Opinion',
      '440': 'Get results',
      '450': 'The evaluation',
      '460': 'Sign',
      '470': 'Date',
      '480': 'Performance evaluation forms.'
    },
    'HRPM31EP2': {
      '10': 'AP Form No.',
      '15': '(Print Appraisal Form)',
      '20': 'Details of Section',
      '30': 'Sec.',
      '40': 'Description',
      '50': 'Weight',
      '60': 'Grad',
      '70': 'Score',
      '80': 'Appraiser"s Comment',
      '90': 'Total by section',
      '100': 'Grand Total',
      '110': 'Grad',
      '120': 'Description',
      '130': 'Score',
      '140': 'Details'
    },
    'HRPM31EP3': {
      '10': 'Details of leave/Abnormal attendance',
      '20': 'Duration from',
      '30': 'To date',
      '40': 'Details of leave',
      '50': 'Details of Abnormal attendance',
      '60': 'Type',
      '70': 'leave',
      '80': 'Detail',
      '90': 'No. of leave',
      '100': 'D:H:M',
      '110': 'Type of Abnormal',
      '120': 'Number of times',
      '130': 'D:H:M',
      '140': 'Late',
      '150': 'Early',
      '160': 'Absence',
      '170': 'Details of misconduct /action',
      '180': 'Effective Date',
      '190': 'Details of the misconduct'
    }
  },
  'th': {
    'HRPM31EC1': {
      '10': 'สำหรับหน่วยงาน',
      '20': 'วันที่ครบกำหนดตั้งแต่',
      '30': 'ถึง',
      '40': 'หรือ รหัสพนักงาน',
      '50': 'รหัสพนักงาน',
      '60': 'ชื่อพนักงาน',
      '70': 'หน่วยงาน',
      '80': 'ตำแหน่ง',
      '90': 'ประเภทการทดลองงาน',
      '99': 'การทดลองงานของพนักงาน',
      '100': 'วันที่เข้างาน',
      '110': 'วันที่ครบกำหนด',
      '120': 'อนุมัติข้ามขั้นตอน',
      '130': 'สถานะการอนุมัติ'
    },
    'HRPM31EP1': {
      '10': 'รหัสพนักงาน',
      '20': 'ลำดับที่ผู้ประเมิน',
      '30': 'รหัสผู้ประเมิน',
      '40': 'สรุปผลการประเมิน',
      '50': 'รายละเอียดการประเมิน',
      '60': 'ข้อมูลการลา/ผิดปกติ',
      '70': 'ประเภทการทดลองงาน',
      '80': 'จำนวนผู้ประเมินที่กำหนด',
      '90': 'คน',
      '100': 'จำนวนผู้ประเมินที่ประเมินแล้ว',
      '110': 'คน',
      '120': 'วันที่เริ่มงาน/เริ่มตำแหน่ง',
      '130': 'วันที่ครบกำหนดทดลองงาน',
      '140': 'วันที่ประเมิน',
      '150': 'คะแนนการประเมิน',
      '160': 'ผลการประเมิน',
      '170': 'ขยายทดลองงาน(วัน)',
      '180': 'หมายเหตุ',
      '190': 'สาเหตุที่ไม่ผ่าน',
      '200': 'สถานะการประเมิน',
      '210': 'In Process',
      '220': 'Completed',
      '230': 'รายละเอียดทดลองงาน/ตำแหน่ง',
      '240': 'รายละเอียดทดลองงาน/ตำแหน่ง',
      '250': 'รหัสพนักงาน',
      '260': 'หน่วยงาน',
      '270': 'วันที่เข้างาน',
      '280': 'ตำแหน่ง',
      '290': 'วันที่กลับเข้าทำงานใหม่',
      '300': 'ลักษณะงาน',
      '310': 'กำหนดทดลองงาน(วัน)',
      '320': 'ประเภทการจ้างงาน',
      '330': 'วันที่ครบกำหนด',
      '340': 'ประเภทพนักงาน',
      '350': 'ประเภทการทดลองงาน',
      '360': 'ส่วนที่',
      '370': 'สรุปผลการประเมิน',
      '380': 'ผ่าน',
      '390': 'ไม่ผ่าน',
      '400': 'ขยายระยะเวลาทดลองงาน',
      '410': 'วัน',
      '420': 'หมายเหตุ',
      '430': 'สรุปความเห็น',
      '440': 'รับทราบผลการประเมิน',
      '450': 'ผู้ประเมินผล',
      '460': 'ลงชื่อ______________________________',
      '470': 'วันที่______________________________',
      '480': 'แบบฟอร์มการประเมินผลการปฏิบัติงาน'
    },
    'HRPM31EP2': {
      '10': 'แบบฟอร์มการประเมิน',
      '15': '(พิมพ์แบบฟอร์มการประเมิน)',
      '20': 'หัวข้อการประเมินสำหรับส่วนที่',
      '30': 'ข้อที่',
      '40': 'รายละเอียด',
      '50': 'น้ำหนัก',
      '60': 'เกรด',
      '70': 'คะแนนที่ได้',
      '80': 'รายละเอียดเพิ่มเติมของหัวหน้างาน',
      '90': 'รวมส่วน',
      '100': 'รวมแบบฟอร์ม',
      '110': 'เกรด',
      '120': 'รายละเอียด',
      '130': 'คะแนนที่ได้',
      '140': 'คำจำกัดความ'
    },
    'HRPM31EP3': {
      '10': 'รายละเอียดการลา/การมาปฎิบัติงานผิดปกติ และการกระทำผิดลงโทษ',
      '20': 'ระหว่างวันที่',
      '30': 'ถึงวันที่',
      '40': 'รายละเอียด',
      '50': 'รายละเอียดการปฎิบัติงานผิดปกติ',
      '60': 'ประเภท',
      '70': 'การลา',
      '80': 'รายละเอียด',
      '90': 'จำนวนลา',
      '100': 'วัน:ชม.:นาที',
      '110': 'ประเภทความผิดปกติ',
      '120': 'จำนวนครั้ง',
      '130': 'วัน:ชม.:นาที',
      '140': 'สาย',
      '150': 'กลับก่อน',
      '160': 'ขาดงาน',
      '170': 'รายละเอียดการกระทำผิด/ลงโทษ',
      '180': 'วันที่มีผล',
      '190': 'รายละเอียดการกระทำผิด'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms31e.js